export default __webpack_public_path__ + "static/experiential-marketing-bbed119d464642e0294725c26d7390d8.jpg";